import {
  sendClientRequestV2,
  sendClientRequestV3,
  getDeviceInfo,
  SchemaErrorCode,
} from '@xhs/ozone-bridge'
import xhrAdapter from 'axios/lib/adapters/xhr' // eslint-disable-line import/no-extraneous-dependencies
import buildURL from 'axios/lib/helpers/buildURL' // eslint-disable-line import/no-extraneous-dependencies
import { HTTPClientError } from '@xhs/http/src/lib/errors' // eslint-disable-line import/no-unresolved

let isNativeSupportV3
// 是否支持 sendClientRequestV3
async function isSupportV3Invoke() {
  if (typeof isNativeSupportV3 !== 'undefined') {
    return isNativeSupportV3
  }
  try {
    const { buildNumber } = await getDeviceInfo()
    isNativeSupportV3 = buildNumber >= '6630000'
  } catch (error) {
    isNativeSupportV3 = false
  }
  return isNativeSupportV3
}

function transformToSearchParams(data) {
  if (!data) {
    return ''
  }
  const params = new URLSearchParams()

  Object.entries(data).forEach(item => {
    const [key, value] = item
    params.append(key, value)
  })
  return params.toString()
}

// sendClientRequestV3 逻辑
async function sendClientRequestV3Adapter(config) {
  const {
    method, url, params, paramsSerializer, data, headers,
  } = config
  const requestMethod = method.toUpperCase()
  const { 'Content-Type': contentType } = headers || {}
  // 非GET请求，不支持非JSON、FORM的请求
  if (requestMethod !== 'GET' && (!(contentType || '').match(/application\/x-www-form-urlencoded|application\/json/) || data instanceof FormData)) {
    return xhrAdapter(config)
  }
  try {
    // 消费者传入的 data 是 object 时，会被 axios 的 transformRequest 转换为 json string
    // 但是 sendClientRequest 的 data 只支持传入 object，因此这里需要 JSON.parse
    const newData = data === undefined ? data : JSON.parse(data)

    const newUrl = buildURL(url, params, paramsSerializer)
    const requestParams = {
      method: requestMethod,
      url: newUrl,
      headers,
    }
    // POST PUT DELETE 传递 body
    let bodyString = null
    if (requestMethod !== 'GET') {
      if (contentType === 'application/x-www-form-urlencoded') {
        bodyString = transformToSearchParams(newData)
      } else {
        bodyString = JSON.stringify(newData)
      }
      requestParams.body = bodyString
    }
    const res = await sendClientRequestV3(requestParams)
    const { result, value: response, message } = res
    if (result === 0) {
      return {
        data: response.body,
        status: response.status,
        headers: response.headers,
        config,
      }
    }
    throw new Error(`The result returned from sendClientRequestV3 bridge is not 0, the result code is ${result}, the message is ${message}`)
  } catch (err) {
    // sendClientRequestV3 不支持或者没有在 XHSWebView 中
    if (err.code === SchemaErrorCode.NotSupport || err.code === -10000) {
      console.warn(`[Launcher Http] Run "${method} ${url}" request with sendClientRequestV3 fail, make sure your app verion >= 6.63 and run in XHSWebView`) // eslint-disable-line no-console
      return xhrAdapter(config)
    }
    throw new HTTPClientError('EUseBridgeV3Error', err.message)
  }
}

// sendClientRequestV2 的逻辑保持不变
async function sendClientRequestV2Adapter(config) {
  const {
    method, url, params, paramsSerializer, data,
  } = config
  const newData = data === undefined ? data : JSON.parse(data)
  try {
    const newParams = {
      ...params,
      sid: undefined, // Bridge will add this, we can't do it before
    }
    const newUrl = buildURL(url, newParams, paramsSerializer)

    // 消费者传入的 data 是 object 时，会被 axios 的 transformRequest 转换为 json string
    // 但是 sendClientRequestV2 的 data 只支持传入 object，因此这里需要 JSON.parse
    const { result, response } = await sendClientRequestV2({
      type: method.toUpperCase(),
      url: newUrl,
      data: newData,
    })

    if (result === 0) {
      return {
        data: response.body,
        status: response.status,
        headers: response.headers,
        config,
      }
    }
    throw new Error('The result returned from sendClientRequestV2 bridge is not 0')
  } catch (err) {
    if (process.env.NODE_ENV === 'development' && err.code === 'ERR_NOT_SUPPORT') {
      console.warn(`[Launcher Http] Run "${method} ${url}" in browser for development, when deployed to production, it only run in XHSWebView and failed in browsers`) // eslint-disable-line no-console

      if ((method === 'post' || method === 'put' || method === 'patch') && config.headers) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
        config.data = transformToSearchParams(newData)
      }
      return xhrAdapter(config)
    }
    throw new HTTPClientError('EUseBridgeError', err.message)
  }
}

export default async function xhrByBridgeAdapter(config) { //eslint-disable-line
  const {
    method, preferBridge: useV3Bridge = false, useBridge: useV2Bridge = false,
  } = config
  // 默认都不走 bridge 请求
  if (!useV3Bridge && !useV2Bridge) {
    return xhrAdapter(config)
  }
  try {
    // 用户指定了 V3 bridge 请求
    if (useV3Bridge) {
      return sendClientRequestV3Adapter(config)
    }

    // 用户指定了 V2 bridge 请求
    if (useV2Bridge) {
      console.warn('[Launcher Http] useBridge was deprecated, please use preferBridge') // eslint-disable-line no-console
      // 是否支持 V3 bridge
      const nativeSupportV3 = await isSupportV3Invoke()
      // 如果条件允许升级为 V3 bridge
      if (nativeSupportV3) {
        if ((method === 'post' || method === 'put' || method === 'delete') && config.headers) {
          // Content-Type 指定为 V2 bridge 支持的格式
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
          return sendClientRequestV3Adapter(config)
        } if (method === 'get') {
          return sendClientRequestV3Adapter(config)
        }
      }
      return sendClientRequestV2Adapter(config)
    }
  } catch (err) {
    throw new HTTPClientError('EUnknowHttpError', err.message)
  }
}
